<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'system-thdapiOaResultApiSet',
  components: {
    PageTable,
  },
}
</script>
